import { render, staticRenderFns } from "./approvalsTable.vue?vue&type=template&id=e54feec8&scoped=true"
import script from "./approvalsTable.vue?vue&type=script&lang=js"
export * from "./approvalsTable.vue?vue&type=script&lang=js"
import style0 from "./approvalsTable.vue?vue&type=style&index=0&id=e54feec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54feec8",
  null
  
)

export default component.exports